import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private http: HttpClient, private occService:OccEndpointsService) { }

  getRegisterPageFields(){
    return this.http.get(this.occService.buildUrl(`kbregistration/registerpagefields`));
  }

  getRegions(isoCode){
    return this.http.get(this.occService.buildUrl(`kbregistration/regions/?countryIso=${isoCode}`));
  }

  signUpUser(reqPayload){
    return this.http.post(this.occService.buildUrl('kbregistration'),reqPayload);
  }

  registerConfirmation(token){
    return this.http.post(this.occService.buildUrl(`kbregistration/registerconfirmaton?token=${token}`),{});
  }

  checkExistingEmail(email){
    return this.http.get(this.occService.buildUrl(`kbregistration/validateemail?email=${email}&fields=FULL`))
  }
}
